<template>
  <div class="drilldown-button">
    <UiButton
      :disabled="disabledBtn"
      :icon="icon"
      class="drilldown-button__left"
      @click="disabledDropdown
        ? createReport(null)
        : drilldownReport()"
    >
      {{ btnTitle }}
    </UiButton>
    <ElDropdown
      :class="{'disabled': disabledDropdown}"
      :disabled="disabledDropdown"
      trigger="click"
    >
      <UiButton
        class="drilldown-button__right"
        icon="chevron-down"
        is-icon
        :disabled="disabledDropdown"
      />
      <template v-slot:dropdown>
        <ElDropdownMenu
          :class="{'disabled': disabledDropdown}"
          class="drilldown-button__dropdown ddgroup"
        >
          <ElDropdownItem>
            <div
              @click="createReport(report, 'continue')"
            >
              {{ $t('reports.other.continue_new_tab') }}
            </div>
          </ElDropdownItem>
          <ElDropdownItem>
            <div @click="createReport(null)">
              {{ $t('reports.other.start_new_tab') }}
            </div>
          </ElDropdownItem>
        </ElDropdownMenu>
      </template>
    </ElDropdown>
  </div>
</template>

<script>
export default {
  name: 'DrilldownButton',
  props: {
    report: {
      type: Object,
      required: true,
    },
    typeAction: {
      type: String,
      required: true,
    },
    disabledBtn: {
      type: Boolean,
      default: false,
    },
    disabledDropdown: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['drilldownReport', 'createReport'],

  data() {
    return {
      action: this.typeAction === 'exclude' ? '!=' : '=',
      icon: this.typeAction === 'exclude' ? 'page-break' : 'random',
    };
  },

  methods: {
    createReport(data, continueType) {
      this.$emit('createReport', data, this.action, continueType);
    },

    drilldownReport() {
      this.$emit('drilldownReport', this.action);
    },
  },
  computed: {
    btnTitle() {
      return this.typeAction === 'exclude' ? this.$t('reports.other.exclude') : this.$t('reports.other.drilldown');
    },
  },
};
</script>

<style lang="scss">
.drilldown-button {
  display: flex;
}
.ui-button.drilldown-button{
  &__left{
    border-radius: 5px 0 0 5px;
  }
  &__right{
    border-radius: 0 5px 5px 0;
    border-left: none;
  }
  &__dropdown {
    .el-dropdown-menu__item {
      padding-left: 0 !important;
      padding-right: 0 !important;
      > div {
        display: flex;
        height: 100%;
        width: 100%;
        align-items: center;
        padding-left: 8px;
        padding-right: 24px;
      }
    }
    &.disabled {
      display: none;
    }
  }
}
</style>
